import type { AiBusinessCenterModule } from '../types'

/** 城市治理独立应用配置。 */
export const cityGovernanceModule: AiBusinessCenterModule = {
  key: 'city-governance',
  label: '城市治理',
  desc: '智慧城管、安防、应急、交通、能源与环保一网统管',
  path: '/city-governance',
  homePath: '/city-governance/smart-city/overview/dashboard',
  icon: 'ep:office-building',
  color: '#3b82f6'
}
